import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { generateHistoricsPDF } from 'lib/pdfs/HistoricsPDF';
// Cambiar por generatePDF Historics

import { acceptHistoric, rejectHistoric } from 'containers/assets/actions';
import { addGrowlSuccess, addGrowlError } from 'messages/actions';
import * as Reports from 'reports/components';
import { getHistoricsReport } from 'reports/actions';
import { getHistoricsReportPagination, getHistoricsReportFilters } from 'reports/selectors';

import { getLocations } from 'selectors/lists';
import debounce from 'lodash/debounce';

import { getCompany, getSubcompany, getPermissions } from 'auth/selectors';
import { getHistoricsIsSaving } from 'selectors/assets';

class HistoricsReportRow extends Component {
  static propTypes = {
    record: PropTypes.object.isRequired,
  };

  state = { collapsed: true };

  fetch = () => {
    const { company, subcompany, pagination, filters } = this.props;

    this.props.getReport(
      company.id,
      subcompany.id,
      filters,
      pagination.limit,
      pagination.page,
      pagination.orderBy,
      pagination.order
    );
  };

  fetchDebounce = debounce(this.fetch, 200);

  handleToggleCollapsed = () => this.setState({ collapsed: !this.state.collapsed });

  handleGeneratePDF = (record) => generateHistoricsPDF(record, this.props.subcompany);

  handleAccept = (record) => {
    this.props
      .accept(record.id, record._asset, this.props.company.id, this.props.subcompany.id)
      .then(({ value }) => this.props.success(value.message))
      .then(() => this.fetchDebounce())
      .catch((e) => this.props.error(e.message));
  };
  handleReject = (record) => {
    this.props
      .reject(record.id, record._asset, this.props.company.id, this.props.subcompany.id)
      .then(({ value }) => this.props.success(value.message))
      .then(() => this.fetchDebounce())
      .catch((e) => this.props.error(e.message));
  };

  render = () => (
    <Reports.HistoricsReportRow
      isSaving={this.props.isSaving}
      record={this.props.record}
      locations={this.props.locations}
      collapsed={this.state.collapsed}
      handleToggleCollapsed={this.handleToggleCollapsed}
      handleGeneratePDF={this.handleGeneratePDF}
      handleAccept={this.handleAccept}
      handleReject={this.handleReject}
    />
  );
}

const mapStateToProps = (state) => ({
  filters: getHistoricsReportFilters(state),
  locations: getLocations(state),
  pagination: getHistoricsReportPagination(state),
  isSaving: getHistoricsIsSaving(state),
  company: getCompany(state),
  subcompany: getSubcompany(state),
});
const mapDispatchToProps = {
  getReport: getHistoricsReport,
  accept: acceptHistoric,
  reject: rejectHistoric,
  success: addGrowlSuccess,
  error: addGrowlError,
};

export default connect(mapStateToProps, mapDispatchToProps)(HistoricsReportRow);



// WEBPACK FOOTER //
// src/modules/secured/modules/reports/containers/HistoricsReportRowContainer.js